'use es6';

import { List } from 'immutable';
import extractor from '../../../../config/extractor';
export default (() => extractor(config => config.getIn(['sort'], List()).toJS(), null));